import { logInfo } from '@betty/toolkit/logging';
import { BottomSheet, navigationRef } from '@betty/navigation';
import { socketConnected, startListening } from '@betty/toolkit/state';
import { DepositApprovedEventData } from '../deposit/deposit.types';
import { openWithdrawal, withdrawalApproved } from './withdrawal.slice';
import { WithdrawConfirmationEventData } from './withdrawal.types';
import { selectCashBalance } from '../cashBalance/cashBalance.slice';

startListening({
  actionCreator: openWithdrawal.fulfilled,
  effect: ({ payload }, { getState }) => {
    const { minAmount } = payload;
    const cashBalance = selectCashBalance(getState());

    if (minAmount && minAmount > cashBalance) {
      BottomSheet.open({
        namespace: 'wallet',
        type: 'WithdrawInsufficientFunds',
        data: {
          minAmount,
        },
      });

      return;
    }

    navigationRef.navigate('Withdraw');
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'WithdrawalApproved',
      (data: DepositApprovedEventData) => {
        logInfo('GenericHub', 'WithdrawalApproved', data);

        if (!data) return;

        BottomSheet.open({
          namespace: 'wallet',
          type: 'WithdrawalCompleted',
          singleton: false,
          light: true,
          data: {
            amount: data.amount,
          },
        });

        dispatch(withdrawalApproved(data));
      },
    );
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'WithdrawalConfirmation',
      (data: WithdrawConfirmationEventData) => {
        logInfo('GenericHub', 'WithdrawalConfirmation', data);

        if (!data) return;

        BottomSheet.open({
          namespace: 'wallet',
          type: 'WithdrawConfirmation',
          closeOnBlur: false,
          autoCloseOnNavigation: false,
          showCloseIcon: false,
          enablePanDownToClose: false,
          data: {
            transactionId: data.transactionId,
          },
        });
      },
    );
  },
});
